module.exports = __webpack_public_path__ + "static/media/galleryMask.6cf50085.png";